import _ from 'lodash';
import { bedStatusAPI, eadmissionAPI, systemAPI } from '../../../apis';

export const initTransferInPopupOptions = {
  bsRemarkList: [],
  bsHospcodeList: [],
  bsAttentionList: [],
  sysHospitalWardList: [],
  bsMlookupList: [],
  locationList: [],
  destHospitalOption: [],
};

// 加载当前病区可用的医院和 ward 资料。
const loadSysHospitalWardList = async (loginInfo) => {
  try {
    const { result } = await systemAPI.getSysHospitalWardList({
      hospitalId: loginInfo.hospitalId,
      wardId: loginInfo.wardId,
    });
    return result ?? [];
  } catch {
    return [];
  }
};

// 加载 attention 快捷模板。
const loadAttentionList = async () => {
  try {
    const { result } = await bedStatusAPI.getBsAttentionList();
    return result ?? [];
  } catch {
    return [];
  }
};

// 加载 hospital code 下拉资料。
const loadHospitalCodeList = async () => {
  try {
    const { result } = await bedStatusAPI.getIpasHospList();
    return result ?? [];
  } catch {
    return [];
  }
};

// 加载当前 ward 可用的 remark 快捷模板。
const loadRemarkList = async (wardId) => {
  try {
    const { result } = await bedStatusAPI.getBsRemarkList({ wardId, isActive: 1 });
    return _.map(result?.data ?? [], (item) => {
      return item.remark;
    });
  } catch {
    return [];
  }
};

// 加载 transfer in 使用的 BedStatus lookup 枚举。
const loadLookupList = async () => {
  try {
    const { result } = await bedStatusAPI.getBsMlookupList();
    return result ?? [];
  } catch {
    return [];
  }
};

// 加载 e-admission cubicle location 下拉资料。
const loadCubicleList = async () => {
  try {
    const { result } = await eadmissionAPI.getSOPDCubicleList();
    return _.map(result?.cubicles ?? [], (item) => ({
      value: item?.cubicleId,
      text: item?.name,
    }));
  } catch {
    return [];
  }
};

// 加载目标医院、ward 和 location 级联下拉资料。
const loadDestinationHospitalWardList = async (wardId) => {
  try {
    const { result } = await eadmissionAPI.getHospWardList({ currentWardId: wardId });
    return _.map(result ?? [], (item) => ({
      ...item,
      text: item?.hospCode,
      value: item?.hospCode,
    }));
  } catch {
    return [];
  }
};

export const fetchTransferInPopupOptions = async (loginInfo) => {
  const [
    sysHospitalWardList,
    bsAttentionList,
    bsHospcodeList,
    bsRemarkList,
    bsMlookupList,
    cubicleList,
    destHospitalList,
  ] = await Promise.all([
    loadSysHospitalWardList(loginInfo),
    loadAttentionList(),
    loadHospitalCodeList(),
    loadRemarkList(loginInfo.wardId),
    loadLookupList(),
    loadCubicleList(),
    loadDestinationHospitalWardList(loginInfo?.wardId),
  ]);

  return {
    sysHospitalWardList,
    bsAttentionList,
    bsHospcodeList,
    bsRemarkList,
    bsMlookupList,
    cubicleList,
    destHospitalList,
  };
};

export const buildTransferInBaseSaveParams = (requestVal) => {
  return {
    admissionType: requestVal.admissionType,
    age: Number(requestVal.age ?? requestVal.patDob),
    attention: requestVal.attention,
    caseNo: requestVal.caseNo,
    chiName: requestVal.chiName,
    destHospCode: requestVal.destHospCode,
    destSpecialty: requestVal.destSpecialty,
    destWard: requestVal.destWard,
    destWardId: requestVal.destWardId,
    destWardLocation: requestVal.destWardLocation,
    diagnosis: requestVal.diagnosis,
    eisSpecCd: requestVal.eisSpecCd,
    fromBedNo: requestVal.fromBedNo,
    fromHospCode: requestVal.fromHospCode,
    fromWardLocation: requestVal.fromWardLocation,
    hkid: requestVal.hkid,
    onOxygen: requestVal.onOxygen,
    onVentilator: requestVal.onVentilator,
    oxygenLitre: requestVal.oxygenLitre,
    patGender: requestVal.patGender,
    patName: requestVal.patName,
    patientKey: requestVal.patientKey,
    remark: requestVal.remark,
    targetArriveDtm: requestVal.targetArriveDtm,
    tracheotomy: requestVal.tracheotomy,
    ventilatorPrecentage: requestVal.ventilatorPrecentage,
    cubicleId: requestVal.cubicleId,
    status: requestVal.status,
  };
};

export const buildCreateTransferInParams = (requestVal, wardId) => {
  return {
    ...buildTransferInBaseSaveParams(requestVal),
    wardId,
  };
};

export const buildUpdateTransferInParams = (requestVal) => {
  return {
    ...buildTransferInBaseSaveParams(requestVal),
    transferRequestId: requestVal.transferRequestId,
    version: requestVal.version,
  };
};
